import {
  createActions, asyncInitialState, asyncSelectors
} from '../utils'

export const { types, actions } = createActions({
  setSelected: (row) => ({ row }),
  clear: () => null
}, 'productionOrder');

//const actionListAPI = '/purchaseOrderEnquiry/lookup/action';

const initialState = asyncInitialState({
  selected: null,
  gridOptions: {
    doubleClickActionTab: 'LineDetails',
    suppressEditDeleteInContextMenu: true,
    rowModelType: 'serverSide',
    cacheBlockSize: 10,
    maxBlocksInCache: 5
  },
  deleteObj: null,
  Actions: {
  },
  Columns: [
    { headerName: 'P/O Line', field: 'PurchaseOrderLineNumber', type: 'numericColumn', minWidth: 150 },
    {
      headerName: 'Product', field: 'ProductIdDisplay',
      suppressSorting: true,
      cellRenderer: 'hyperLinkRenderer',
      cellRendererParams: {
        link: '/inventory-enquiry'
      },
      minWidth: 150,
      hyperlinkParamGetter: (row) => {
        if (row.data && row.data.ProductId) {
          return {
            ProductId: row.data.ProductId,
            FieldValue: row.data.ProductIdDisplay
          };
        } else return null;
      },
    },
    { headerName: 'Priority', field: 'Priority' },
    { headerName: 'Production order', field: 'ProductionOrder', suppressSorting: true },
    { headerName: 'Committed', field: 'QtyCommittedDisplay', type: 'numericColumn', suppressSorting: true },
    { headerName: 'Resp person', field: 'UserId', type: 'numericColumn', suppressSorting: true },
    { headerName: 'Earliest due', field: 'DueDate' },
    { headerName: 'Order status', field: 'Status', suppressSorting: true },
    { headerName: 'Description', field: 'ProductionOrderDescription' },
    { headerName: 'Product description', field: 'ProductIdLabel', suppressSorting: true },
    { headerName: 'Product group', field: 'ProductGroup', suppressSorting: true },
  ]
});

export default (state = initialState, action) => {
  switch (action.type) {
    case types.clears:
      return {
        ...state,
        data: {
          ...state.data,
          Data: []
        }
      }
    case types.setSelected:
      const selected = action.data.row;
      return {
        ...state,
        data: {
          ...state.data,
          selected: selected
        }
      }
    default:
      return state;
  }
};

const asyncSelector = asyncSelectors(
  (state) => state.purchaseOrderEnquiry.productionOrder,
  {
    selected: data => data.selected,
    Actions: data => data.Actions,
  }
)

const syncSelector = {
  isLoading: state => state.purchaseOrderEnquiry.productionOrder.loading,
  gridOptions: state => state.purchaseOrderEnquiry.productionOrder.data.gridOptions,
  Columns: state => state.purchaseOrderEnquiry.productionOrder.data.Columns,
  Actions: state => state.purchaseOrderEnquiry.productionOrder.data.Actions,
}

export const selectors = Object.assign({}, asyncSelector, syncSelector)